/* eslint-disable no-template-curly-in-string */
import * as yup from "yup";
export const setupYup = () => {
    yup.setLocale({
        mixed: {
            default: "${path}が不正です。",
            required: "${path}は必須です。",
            oneOf: "${path}の形式が不正です。",
            notOneOf: "${path}の形式が不正です。",
        },
        string: {
            length: "${path}は${length}文字で入力してください。",
            max: "${path}は${max}文字以内で入力してください。",
            min: "${path}は${min}文字以上で入力してください。",
            matches: "${path}の形式が不正です。",
            email: "${path}はメールアドレス形式で入力してください。",
            url: "${path}はURL形式で入力してください。",
            uuid: "${path}はUUID形式で入力してください。",
        },
        number: {
            min: "${path}は${min}以上の値を入力してください。",
            max: "${path}は{max}以下の値を入力してください。",
            lessThan: "${path}は${less}より小さい値を入力してください。",
            moreThan: "${path}は${more}より大きい値を入力してください。",
            positive: "${path}は正の値を入力してください。",
            negative: "${path}は負の値を入力してください。",
            integer: "${path}は整数を入力してください。",
        },
        date: {
            min: "${path}は範囲外です。",
            max: "${path}は範囲外です。",
        },
        object: {
            noUnknown: "不明な項目が含まれています。",
        },
        array: {
            length: "${path}は${length}項目で入力してください。",
            max: "${path}は${max}項目以下で入力してください。",
            min: "${path}は${min}項目以上で入力してください。",
        },
    });
    yup.addMethod(yup.string, "kana", function () {
        return this.test("kana", "${path}はカタカナで入力してください。", function (value) {
            if (!value) {
                return true;
            }
            return /^[0-9\u30A0-\u30FF\s()]+$/.test(value);
        });
    });
    yup.addMethod(yup.string, "number", function () {
        return this.test("number", "${path}は数字で入力してください。", function (value) {
            if (!value) {
                return true;
            }
            return /^[0-9]+$/.test(value);
        });
    });
};
//# sourceMappingURL=yup.js.map